import {reactive} from 'vue'

// Mutace, které cenu píší se symbolem měny za číslem (1 234 Kč / 86,40 €).
// Ostatní (EN, PL, DE) používají kód měny před číslem (EUR 1 234) — viz formatCode*.
// Hodnotou je locale pro Intl, klíčem store.form.language.
const CURRENCY_LOCALES = {CZ: 'cs', SK: 'sk'};

// languageId, pod kterým IS vrací překlad názvu produktu v nameTranslations.
// Klíčem je store.form.language, viz src/composables/useProductName.js.
export const IS_PRODUCT_LANGS = {CZ: 'cs', EN: 'en', PL: 'pl', DE: 'de', SK: 'sk'};

export const store = reactive({
    debug: false,
    apiDebug: false,
    gaSwitch: true,
    form: {
        currentStep: 'stepOne',
        steps: {
            'stepOne': {
                filled: false,
                blurred: false,
                visited: true,
            },
            'stepTwo': {
                filled: false,
                blurred: false,
                visited: false,
            },
            'stepThree': {
                filled: false,
                blurred: false,
                visited: false,
            },
            'stepFour': {
                filled: false,
                blurred: false,
                visited: false,
            },

        },
        formEditing: false, // pro "opravdu odejít" popup.
        currency: import.meta.env.VITE_CURRENCY, // NOTE: nastavení měny pro košík (EUR|CZK)
        language: import.meta.env.VITE_LANGUAGE === 'cs' ? 'CZ' : import.meta.env.VITE_LANGUAGE.toUpperCase(), // NOTE: odesílá se do raynet - info v jaké jazykové mutaci je formulář (CZ|EN)
        hideSalePromoInfo: import.meta.env.VITE_HIDE_SALE_PROMO_INFO === "true",
        priceListName: 'Ceník ' + import.meta.env.VITE_CURRENCY, // NOTE: nastavení ceníku pro košík (Cenik EUR|Cenik CZK)
        druhyZivnostiCodes: ['ZU02', 'ZU03', 'ZU06', 'ZU04', 'OS01', 'ZU01'], // slouzi pro vyhledani a doplneni cen
        druhyZivnostiProducts: [],
        usedProducts: ['NZ01','NZ02','SOP_02','ZU12',,'ZU11','KO02','OR01'],
        seatsCodes: [
            'SP10',
            'SP12',
            'SP03',
            'SP05_12',
            'SP01',
            'SP11',
            'SP20',
            'SP09',
            'SP02',
        ],
        defaultSeatCode: import.meta.env.VITE_DEFAULT_SEAT_SELECTED_CODE,
        seatsProducts: [],
        sameInvoiceAddressOwnSeat: true,
        formSucceed: false,
        formSending: false,
        osoba: '',
        mamIco: '',
        vyrizeniZmenySidla: false,
        sidloVeSmlouve: '',
        adresaSidlaJe: ''
    },

    order: {
        type: 'order',
        contactInfo: {
            firstName: '',
            surName: '',
            email: '',
            phone: '',
            phoneCountry: null,
            phoneCountryCustom: null,
            poznamka: '',
            // street: '',
            // city: '',
            // country: null,
            // otherCountry: '',
            // psc: '',
            address: {
                invoiceAddress: {
                    ico: '',
                    dic: '',
                    companyName: '',
                    street: '',
                    city: '',
                    psc: '',
                    country: '',
                    otherCountry: '',
                },
                companyAddress: {
                    ico: '',
                    dic: '',
                    companyName: '',
                    street: '',
                    city: '',
                    psc: '',
                    country: '',
                    otherCountry: '',
                }
            }
        },
        // udajeOSubjektu: {
        //     ico: '',
        //     dic: '',
        //     companyName: '',
        //     street: '',
        //     city: '',
        //     psc: '',
        //     country: '',
        //     otherCountry: '',
        // },
        // cinnost: 'main',
        // oborZivnosti: '',
        customerWantNextServices: false,
        paymentType: 'payment.callToActionText',
        // healthInsurance: '',
        // seatChoose: '',
        // ownSeatAddress: {
        //     street: '',
        //     city: '',
        //     country: 'Česká republika',
        //     psc: ''
        // },
        checkAgreement: false,
        checkPersonalInfo: false,
        checkTermsAndConditions: false,
        fakturovatNaStejnouFirmu: false,
        products: [],
        payments: {},
        raynetLeadId: null,
        uuid: null
    },

    urls: {
        //strapiUrl : 'http://localhost:1337/api/orders',
        // strapiUrl: 'https://seal-app-2bvf4.ondigitalocean.app/api/orders',
        strapiUrl: import.meta.env.VITE_STRAPI_URL,
        //jakeSwissUrl: 'http://192.168.0.109:800',
        //jakeSwissUrl: 'https://dev-dot-jake-james-tools.ey.r.appspot.com/',
        // jakeSwissUrl: 'https://jake-james-tools.ey.r.appspot.com',
        jakeSwissUrl: import.meta.env.VITE_JAKE_SWISS_URL,
        IsUrlProducts: 'https://jake-james-is2-api.appspot.com/_ah/api/web/v1/product?limit=999999&offset=0',
    },

    getVatForProduct(product) {
        var result = product.prices.find(element => element.priceListName === this.priceListName);
        //console.log('test vatu:' + result.vatRate.vatRate);

        if (result.vatRate.vatRate === 0) {
            //  console.log('nulova hodnota, vracim jednicku')
            return 1;
        }
        return (result.vatRate.vatRate / 100) + 1;
    },

    calcOrderTotalPriceNoVat() {
        var price = 0;
        if (this.order.products.length > 0) {
            for (const element of this.order.products) {
                if (element.type === 'seat') {
                    price += element.totalPriceWithoutVat;
                } else price += element.totalPriceWithoutVat;
            }
            return price;
        } else return 0;

    },
    calcOrderTotalPriceWithVat() {
        var price = 0;
        if (this.order.products.length > 0) {
            for (const element of this.order.products) {
                if (element.type === 'seat') {
                    price += element.totalPriceWithVat;
                } else price += element.totalPriceWithVat;
            }
            return price;
        } else return 0;

    },
    // product from json
    getProduct(code) {
        return this.products.find(element => element.code === code);
    },
    getOrderProduct(code) {
        return this.order.products.find(element => element.code === code);
    },
    addProduct(code) {
        if (!this.isProductInOrder(code))
            this.order.products.push(this.getProduct(code));
    },
    removeProduct(code) {
        if (this.isProductInOrder(code)) {
            const findIndex = this.order.products.findIndex(a => a.code === code)
            findIndex !== -1 && this.order.products.splice(findIndex, 1)

        }
    },
    isProductInOrder(code) {
        // console.log(this.order.products);
        return this.order.products.find(elemenet => elemenet.code === code);
    },
    priceFilter(price) {
        var modulo = price % 1;
        if (!modulo)
            return this.formatPriceNoFraction(price)
        else
            return this.formatPriceFraction(price)
        // var formatter = new Intl.NumberFormat('cs', {
        //     style: 'currency',
        //     currency: this.form.currency,
        //     minimumFractionDigits: 0,
        //     maximumFractionDigits: 2,
        // });
        // return formatter.format(price);
    },
    formatPriceNoFraction(price) {
        if (CURRENCY_LOCALES[this.form.language])
            return this.formatSymbolNoFraction(price);
        else
            return this.formatCodeNoFraction(price);

    },
    formatPriceFraction(price) {
        if (CURRENCY_LOCALES[this.form.language])
            return this.formatSymbolFraction(price);
        else
            return this.formatCodeFraction(price);
    },
    formatSymbolNoFraction(price) {
        var formatter = new Intl.NumberFormat(CURRENCY_LOCALES[store.form.language] || 'cs', {
            style: 'currency',
            currency: store.form.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return formatter.format(price)
    },
    formatSymbolFraction(price) {
        var formatter = new Intl.NumberFormat(CURRENCY_LOCALES[store.form.language] || 'cs', {
            style: 'currency',
            currency: store.form.currency,
            maximumFractionDigits: 2
        });
        return formatter.format(price)
    },
    formatCodeNoFraction(price) {
        const number = new Intl.NumberFormat('cs-CZ', {
            style: 'decimal',
            maximumFractionDigits: 0
        }).format(price);

        return `EUR ${number}`;
    },
    formatCodeFraction(price) {
        const number = new Intl.NumberFormat('cs-CZ', {
            style: 'decimal',
            maximumFractionDigits: 2
        }).format(price);

        return `EUR ${number}`;
    },
    previousStep() {

        if (this.form.currentStep === 'stepTwo') {
            this.form.steps.stepOne.filled = false;
            // this.pscFilter();
            this.form.currentStep = 'stepOne';
            this.scrollTop();
        } else if (this.form.currentStep === 'stepThree') {
            this.form.steps.stepTwo.filled = false;
            this.form.currentStep = 'stepTwo';
            this.scrollTop();
        } else if (this.form.currentStep === 'stepFour') {
            this.form.steps.stepFour.filled = false;
            this.form.currentStep = 'stepThree';
            this.scrollTop();
        }

    },
    goToStep(stepName) {
        var step = null;
        if (stepName === 'stepOne') {
            step = this.form.steps.stepOne;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepOne';
                this.scrollTop();
            }
        } else if (stepName === 'stepTwo') {
            step = this.form.steps.stepTwo;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepTwo';
                this.scrollTop();
            }
        } else if (stepName === 'stepThree') {
            step = this.form.steps.stepThree;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepThree';
                // this.sameInvoiceAddressOwnSeat();
                this.scrollTop();
            }
        } else if (stepName === 'stepFour') {
            step = this.form.steps.stepFour;
            if (step.visited) {
                step.filled = false;
                this.form.currentStep = 'stepFour';
                this.scrollTop();
            }
        }

    },
    getPriceTotalZivnosti() {
        var zivnosti = this.order.products.filter(obj => {
            return obj.type === 'tradeType'
        });
        var price = 0;
        for (const element of zivnosti) {
            price += element.totalPriceWithoutVat;
        }
        return price;
    },

    getSeatProduct() {
        // if (this.order.seatChoose === 'virtual') {
        return this.order.products.filter(obj => {
            return obj.type === 'seat'
        });
        // }
    },

    // filter
    pscFilter() {
        var psc = String(this.order.ownSeatAddress.psc);
        psc = psc.replace(' ', '');
        this.order.ownSeatAddress.psc = psc.slice(0, 3) + ' ' + psc.slice(3);
    },
    pscFilterInvoice() {
        var psc = String(this.order.contactInfo.psc);
        psc = psc.replace(' ', '');
        this.order.contactInfo.psc = psc.slice(0, 3) + ' ' + psc.slice(3);
    },
    phoneNumberSpacesFilter() {
        // console.log('dat mezery')
        if (store.order.contactInfo.phoneCountry.value !== 'other') {
            var phone = String(this.order.contactInfo.phone);
            phone = phone.replace(' ', '');
            phone = phone.replace('+', '');
            if (phone.startsWith(this.order.contactInfo.phoneCountry.value)) {
                phone = phone.slice(this.order.contactInfo.phoneCountry.value.length)
            }
            this.order.contactInfo.phone = phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6, 9) + ' ' + phone.slice(9);
        }
    },

    lettersInPhoneNumberInput() {
        // console.log('pryc pismena')
        //store.order.contactInfo.phone = String(store.order.contactInfo.phone).replace(/(\+420)?(00420)?(\+1)?/g, '');
        store.order.contactInfo.phone = String(store.order.contactInfo.phone).replace(/\D/g, '');
        if (store.order.contactInfo.phoneCountry.value === 'other') {
            store.order.contactInfo.phone = '+' + store.order.contactInfo.phone;
        }
    },

    // U volby "Jiné" je předvolba už v čísle, text volby do telefonu nepatří.
    getFormattedPhoneNumber() {
        const o = this.order;
        if (!o.contactInfo.phoneCountry) return o.contactInfo.phone || '';
        if (o.contactInfo.phoneCountry.value === 'other') {
            return o.contactInfo.phone || '';
        }
        return o.contactInfo.phoneCountry.text + ' ' + (o.contactInfo.phone || '');
    },

    scrollTop() {

        let target = document.querySelector('#appJakeSeatForm');
        let headerOffset = 100;
        let elementPosition = target.offsetTop;

        if (window.innerWidth < 992)
            headerOffset = -200;

        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    },
    scrollToErrorInput() {
        if (window.innerWidth <= 767) {
            let target = document.getElementsByClassName('is-invalid')[0];
            // console.log("scroll to error");
            // console.log("target: ", target);
            if (target) {
                let headerOffset = 135;
                let offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                // console.log("offsetPossition", offsetPosition);
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    },
    pushDataLayer(data) {
        // tracking nesmí rozbít odeslání formu (dataLayer chybí nebo ho stránka přepsala)
        try {
            window.dataLayer = window.dataLayer || [];
            return window.dataLayer.push(data);
        } catch (e) {
            console.error('dataLayer push selhal', e);
        }
    },
    sendGaEvent(label, event = 'tradeForm') {
        if (this.gaSwitch) {
            var ga = this.pushDataLayer({
                'event': 'tradeForm: ' + event,
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': label
            });
            // console.log(ga, 'GA event');
        }
    },
    gaEventNextStep(toStep) {
        if (this.gaSwitch) {
            var url = window.location.href;
            var ga = this.pushDataLayer({
                'event': 'formNextStep',
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': 'tradeForm - ' + toStep + '(' + this.order.type + ') - ' + url
            });
            // console.log(ga, 'GA event Next Step');
        }
    },
    gaEventFinishForm() {
        if (this.gaSwitch) {
            var url = window.location.href;
            var ga = this.pushDataLayer({
                'event': 'formConversion',
                'event_category': 'Form',
                'event_action': 'Click',
                'event_label': 'tradeForm - (' + this.order.type + ') - ' + url
            });
            if (this.order.type === "demand") {
                this.gaEventFinishDemand()
            }
            // console.log(ga, 'GA event finish form');
        }
    },
    gaEventFinishDemand() {
        if (this.gaSwitch){
            const priceNoVat = this.calcOrderTotalPriceNoVat();
            const priceWithVat = this.calcOrderTotalPriceWithVat();
            this.pushDataLayer({
                "event": "generate_lead",
                lead_source: "Poptávka - " + this.getSeatProduct()[0].name,
                value: priceNoVat, //celková hodnota všech produktů bez DPH
                tax: Math.round((priceWithVat - priceNoVat)*100)/100, //celková hodnota daně
                shipping: 0, //cena poštovného, u J&J pravděpodobně všude nula
                currency: import.meta.env.VITE_CURRENCY,
                items: this.createGaEventItemsData()
            })
        }
        // gtag("event", "generate_lead", {
        //     lead_source: "Poptávka - " + this.getSeatProduct()[0].name
        // })
    },
    gaEventFinishOrder() {
        if (this.gaSwitch)
            this.pushDataLayer(this.createGaEventFinishOrderData());
        // gtag("event", "purchase", this.createGaEventFinishOrderData())
    },
    createGaEventFinishOrderData() {
        try {
            const priceNoVat = this.calcOrderTotalPriceNoVat();
            const priceWithVat = this.calcOrderTotalPriceWithVat();
            return {
                "event": "purchase",
                transaction_id: this.order.uuid, //ID objednávky
                value: priceNoVat, //celková hodnota všech produktů bez DPH
                tax: Math.round((priceWithVat - priceNoVat)*100)/100, //celková hodnota daně
                shipping: 0, //cena poštovného, u J&J pravděpodobně všude nula
                currency: import.meta.env.VITE_CURRENCY,
                // coupon: "SLEVA20", // v tuto chvíli asi na webu nemáme podporu kupónů, kdyby se někdy objevila, může být v tomto poli
                payment_type: this.order.paymentType === 'payment.card' ? "karta" : "faktura", //způsob platby TODO kartou nebo bankou. má zde být tedy faktura a karta?
                items: this.createGaEventItemsData()
            }
        } catch (e) {
            console.log(e);
        }
    },
    createGaEventItemsData() {
        return this.order.products.map((item, index) => {
            return {
                item_id: item.code, //ID produktu v objednávce
                item_name: item.name, // název produktu
                index: index,
                coupon: "",
                discount: 0,
                item_brand: "Jake&James",
                // item_category: "Virtuální sídla",
                // item_category2: t('sidla' + seat.codeForTran).split('-')[0].split(' ')[0], // Praha/Brno
                // item_variant: t('sidla' + seat.codeForTran).split('-')[0], //Praha 2
                price: this.getGaEventItemPrice(item), //cenu a množství můžeme uvádět buď ve formátu cena za měsíc a počet měsíců nebo cena za rok a počet let, osobně preferuji spíš měsíce, kdyby se v budoucnu umožnila objednávka i na kratší období než je rok
                // promotion_id: "P_12345",
                // promotion_name: "Summer Sale",
                quantity: item.months ? parseInt(item.months) : 1 //pokud se rozhodneme pro cestu měsíční evidence, uvádíme jeden rok hodnotou 12
            }
        })
    },
    getGaEventItemPrice(item) {
        if (item.type === "seat") {
            return item.totalPriceWithoutVat / parseInt(item.months);
        } else return item.totalPriceWithoutVat
    },
    gaEventErrorForm(onStep) {
        if (this.gaSwitch) {
            var url = window.location.href;
            var ga = this.pushDataLayer({
                'event': 'formValidationError',
                'event_category': 'Form',
                'event_action': 'Validation',
                'event_label': 'tradeForm - ' + onStep + ' (' + this.order.type + ') - ' + url
            });
            // console.log(ga, 'GA event validation error form');
        }
    },
    seatClarityEvent(name) {
        var event_name = 'seat-order-form_' + name;
        this.clarityEvent(event_name);
    },
    vueClarityEvent(name) {
        var event_name = 'vue-form_' + name;
        this.clarityEvent(event_name);
    },
    clarityEvent(event_name) {
        // Clarity event
        if (typeof window.clarity === 'function') {
            clarity('event', event_name);
        } else {
            // console.warn('Clarity is not initialized');
        }
    }
})